import { useState, useCallback, ChangeEvent, DragEvent } from 'react';

// 定义上传文件的回调类型
type FileUploadCallback = (files: File[]) => void;

// 定义 useFileUpload Hook 返回的类型
interface UseFileUpload {
    files: File[];
    handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleDrop: (event: DragEvent<HTMLDivElement>) => void;
    handleDragOver: (event: DragEvent<HTMLDivElement>) => void;
    clearFiles: () => void;
}

function useFileUpload(onFileUpload?: FileUploadCallback): UseFileUpload {
    const [files, setFiles] = useState<File[]>([]);

    // 处理文件选择
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const selectedFiles = Array.from(event.target.files || []);
        setFiles(selectedFiles);
        if (onFileUpload) {
            onFileUpload(selectedFiles);
        }
    };

    // 处理拖拽文件
    const handleDrop = (event: DragEvent<HTMLDivElement>): void => {
        window._stat_track('tools_click_ppt_home', {
            click_type: 'upload_file_touch'
        });
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        const lastFiles = droppedFiles[droppedFiles.length - 1];
        setFiles([lastFiles]);
        if (onFileUpload) {
            onFileUpload([lastFiles]);
        }
    };

    // 阻止默认拖拽行为
    const handleDragOver = (event: DragEvent<HTMLDivElement>): void => {
        event.preventDefault();
    };

    // 清空文件列表
    const clearFiles = useCallback(() => {
        setFiles([]);
    }, []);

    return {
        files,
        handleFileChange,
        handleDrop,
        handleDragOver,
        clearFiles
    };
}

export default useFileUpload;
